import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LibIcons } from '../../constants/global.constant';
import { KngLoaderState } from '../loader';
import { KngItemCardData, KngItemCardDataState } from './definitions';
import { KngItemCardFactory } from './kng-item-card.factory';

@Component({
	selector: 'kng-item-card',
	templateUrl: './template/kng-item-card.component.html',
	styleUrls: ['./template/kng-item-card.component.scss']
})
export class KngItemCardComponent implements KngItemCardData
{
	@Input() isServiceView: boolean = false;
	@Input() isIwTelematics: boolean = false;
	@Input() isIwTelematicsNotReporting: boolean = false;
	@Input() isIwTelematicsByPassed: boolean = false;
	@Input() daysNotReporting: string = '';
	@Input() daysByPassed: string = '';
	@Input() isMyFleet: boolean = false;
	@Input() isScheduleMaintenance: boolean = false;
	@Input() hideViewMoreButton: boolean = false;
	private readonly state$: BehaviorSubject<KngItemCardDataState | undefined> =
		new BehaviorSubject<KngItemCardDataState | undefined>(
			KngItemCardFactory.buildState()
		);
  @Input() set state(value: KngItemCardDataState | undefined)
	{
    	this.state$.next(value);
	}
  get state(): KngItemCardDataState | undefined
  {
  	return this.state$.value;
  }
  loaderState: KngLoaderState = {
  	imagePath: LibIcons.raymondWidgetLoader
  };

}
